import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const useTranslationHelper = (key: string, ns = 'translation') => {
  const { t, i18n, ready } = useTranslation(ns, { keyPrefix: key });

  // Memoize the exists function to prevent unnecessary re-creations
  const exists = useMemo(() => (keyToFind: string) => i18n.exists(`${key}.${keyToFind}`, { ns }), [i18n, key, ns]);

  return {
    t,
    i18n,
    ready,
    exists
  };
};
